/* eslint-disable react/button-has-type */
import React, { useRef, useState } from 'react';
import SignaturePad from 'react-signature-canvas';
import { SignatureForm, SignatureDiv } from './WrapperDiv';
export const FormSignature = ({
  handleValidate,
  handleClear,
  readOnly,
  subqchoice
}) => {
  const [className, setClassName] = useState('sigCanvas');
  const padRef = useRef(null);

  const clear = () => {
    if (handleClear) {
      var _padRef$current;

      setClassName('sigCanvas');
      handleClear();
      return (_padRef$current = padRef.current) === null || _padRef$current === void 0 ? void 0 : _padRef$current.clear();
    }

    return null;
  },
        _ref = /*#__PURE__*/React.createElement("button", {
    onClick: clear,
    disabled: readOnly
  }, "Clear");

  const hasSignature = typeof subqchoice.value === 'string' && subqchoice.value.indexOf('data:image') === 0;

  const getReadImage = () => hasSignature ? /*#__PURE__*/React.createElement(SignatureDiv, null, /*#__PURE__*/React.createElement("img", {
    alt: "Signature",
    src: subqchoice.value
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, "No signature");

  const getUI = () => {
    const validate = () => {
      if (handleValidate) {
        var _padRef$current2;

        setClassName('validateCanvas');
        const url = (_padRef$current2 = padRef.current) === null || _padRef$current2 === void 0 ? void 0 : _padRef$current2.getTrimmedCanvas().toDataURL('image/png');

        if (url) {
          handleValidate(url);
        }
      }
    };

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SignaturePad, {
      ref: padRef,
      canvasProps: {
        className
      },
      penColor: "#9edbf7"
    }), /*#__PURE__*/React.createElement("div", {
      id: "sig-preview"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: validate,
      disabled: readOnly
    }, "Validate"), _ref));
  };

  return /*#__PURE__*/React.createElement(SignatureForm, {
    id: "signature-form"
  }, /*#__PURE__*/React.createElement("span", null, subqchoice.questionlabel), readOnly ? getReadImage() : getUI());
};